export default __webpack_public_path__ + "static/media/regulatory--no-parking--g1.4ca5a89f.png";